import { render } from "./SiteLogo.vue?vue&type=template&id=34d99363"
import script from "./SiteLogo.vue?vue&type=script&lang=js"
export * from "./SiteLogo.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__